import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { garrisonMapTeam } = useReportFiltersFetch({ fetchGarrisonMapTeam: true })

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label="Equipe"
                        isMulti={true}
                        wrapValues={true}
                        options={garrisonMapTeam}
                        value={filters.team}
                        onChange={(value) => setFilters(prev => ({...prev, team: value}))}
                        instanceId="team"
                        classNameWrapper={"w-full"}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;